module.exports = [{
      plugin: require('/Users/mitchpierias/Developer/endeavour/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/mitchpierias/Developer/endeavour/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"gatsby-starter-default","short_name":"starter","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"minimal-ui","icon":"src/images/gatsby-icon.png"},
    },{
      plugin: require('/Users/mitchpierias/Developer/endeavour/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
